export default {"src":"/_next/static/media/ethereum.88747d54.svg","height":40,"width":40};